import { Controller } from "@hotwired/stimulus"
import { Chart } from "chart.js"

export default class extends Controller {
  static values = {
    agentCountsValues: Array,
    agentCountsLabels: Array
  }

  connect() {
    this.initializeChart()
  }

  initializeChart() {
    const canvas = this.element.querySelector("#agents-chart")
    if (!canvas) return

    new Chart(canvas, {
      type: "line",
      data: {
        datasets: [{
          data: this.agentCountsValuesValue,
          backgroundColor: ["#18BC9C"],
        }],
        labels: this.agentCountsLabelsValue,
      },
      options: {
        legend: {
          display: false,
        },
        scales: {
          yAxes: [{
            ticks: {
              precision: 0,
              beginAtZero: true
            }
          }]
        },
      }
    })
  }
}
